import { render, staticRenderFns } from "./airdrop.vue?vue&type=template&id=fd482452&scoped=true&"
import script from "./airdrop.vue?vue&type=script&lang=js&"
export * from "./airdrop.vue?vue&type=script&lang=js&"
import style0 from "./airdrop.vue?vue&type=style&index=0&id=fd482452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd482452",
  null
  
)

export default component.exports